module.exports = __webpack_public_path__ + "media/fonts/Roboto-Bold-4f39c5796e60c9d8e7327a00e9a4442e.ttf";